import React from "react";
import { Select as AntdSelect } from 'antd';
interface selectProps {
    value?: string | string[];
    defaultValue?: string | string[];
    onChange?: (value: string | string[]) => void;
    mode?: 'multiple' | 'tags';
    size?: 'large' | 'middle' | 'small';
    filterOption?: boolean | ((input: string, option: any) => boolean);
    showSearch?: boolean;
    placeholder?: string;
    disabled?: boolean;
    allowClear?: boolean;
    autoFocus?: boolean;
    onDropdownVisibleChange?: (open: boolean) => void;
    dropdownRender?: any;
    dropdownClassName?: string;
    optionFilterProp?: string;
    onSearch?: (value: string) => void;
    optionLabelProp?: string;
    getPopupContainer?: (triggerNode: HTMLElement) => HTMLElement;
    open?: boolean;
    className?: string;
    style?: React.CSSProperties;
    defaultActiveFirstOption?: boolean;
    options?: any[];
}

const Select = (props: selectProps) => {
    const {
        value,
        defaultValue,
        onChange,
        options,
        mode,
        filterOption,
        showSearch,
        placeholder,
        allowClear,
        autoFocus,
        onDropdownVisibleChange,
        dropdownRender,
        optionFilterProp,
        onSearch,
        optionLabelProp,
        getPopupContainer,
        open,
        className,
        style,
        disabled
    } = props;

    return (
        <AntdSelect
            value={value}
            defaultValue={defaultValue}
            onChange={onChange}
            mode={mode}
            filterOption={filterOption}
            showSearch={showSearch}
            placeholder={placeholder}
            allowClear={allowClear}
            autoFocus={autoFocus}
            onDropdownVisibleChange={onDropdownVisibleChange}
            dropdownRender={dropdownRender}
            optionFilterProp={optionFilterProp}
            onSearch={onSearch}
            optionLabelProp={optionLabelProp}
            getPopupContainer={getPopupContainer}
            open={open}
            style={style}
            className={className}
            options={options}
            disabled={disabled}
        />
    );
};
export default Select;